import { defineMessages, useIntl } from 'react-intl';
import { Select } from '@cbhq/cds-web/alpha/select';

import type { MemberRole } from '../utils/constants';
import { useRoles } from '../utils/useRoles';

type EntityRoleDropdownProps = {
  value: MemberRole[];
  onChange: (value: MemberRole | MemberRole[] | null) => void;
  variant?: 'negative' | undefined;
  helperText?: string | null;
  testID?: string;
  disabled?: boolean;
};

const messages = defineMessages({
  label: {
    id: 'Team.entityRoleSelectorLabel',
    defaultMessage: 'Roles',
    description: 'Label for the role selector',
  },
  placeholder: {
    id: 'Team.entityRoleSelectorPlaceholder',
    defaultMessage: 'Select roles',
    description: 'Placeholder for the role selector',
  },
});

const selectOverrides = {
  styles: {
    optionDescription: {
      whiteSpace: 'normal',
    },
  },
  classNames: {
    dropdown: 'workspaceSelectHiddenScrollbar',
  },
} as const;

export function EntityRoleDropdown({
  value,
  onChange,
  variant,
  helperText,
  testID,
  disabled,
}: EntityRoleDropdownProps) {
  const { formatMessage } = useIntl();
  const { roleOptions } = useRoles();
  const label = formatMessage(messages.label);

  return (
    <Select
      type="multi"
      {...selectOverrides}
      value={value}
      onChange={onChange}
      options={roleOptions}
      label={label}
      placeholder={formatMessage(messages.placeholder)}
      accessibilityLabel={label}
      variant={variant}
      helperText={helperText}
      testID={testID}
      disabled={disabled}
    />
  );
}
